require('normalize.css/normalize.css');

import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Redirect, browserHistory } from 'react-router';
import { Provider } from 'react-redux'
import { syncHistoryWithStore } from 'react-router-redux';

import store from './store';

import App from './components/App';
import Episodes from './components/Episodes';
import EpisodeContainer from './components/EpisodeContainer';
import Credits from './components/Credits';
import PageNotFound from './components/PageNotFound';

let currentEpisodeId = window.STATE_FROM_SERVER.episodes.currentEpisodeId;


// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store)

// Render the main component into the dom
ReactDOM.render((
  <Provider store={store}>
    <Router onUpdate={() => window.scrollTo(0, 0)} history={history} >
      <Redirect from="?episode=([0-9]{2})(.*)" to="/episode/$1?$2" />
      <Redirect from="/" to={'/episode/'+currentEpisodeId} />

      <Route path="/" component={App} currentEpisodeId={currentEpisodeId} >

        <Route path="episodes" component={Episodes} />

        <Route component={Episodes} >
          <Route path="episode/:episodeId" component={EpisodeContainer} currentEpisodeId={ currentEpisodeId } />
          <Route path="episode/:episodeId/*" component={EpisodeContainer} currentEpisodeId={ currentEpisodeId } />
        </Route>

        <Route path="Credits" component={Credits}/>

        <Route path="*" component={PageNotFound} currentEpisodeId={ currentEpisodeId } />
      </Route>
    </Router>
  </Provider>
), document.getElementById('app'));


//Your initialization

browserHistory.listen( location =>  {
    var url = document.location.href.split("/")
    var ep = parseInt(url[url.length-1]);

    s.clearVars();
    s.pageName=document.title
    s.prop1 = "D=v1" //applicationId
    s.eVar1 = ep<11? "1516.12216.142072" :"1617.12216.145041" //applicationId
    s.prop2 = "D=v2"//siteName
    s.eVar2 = "Suivez le guide – MN" //siteName
    s.prop4 = document.location.href //prev
    s.eVar4 = document.location.href //prev
    s.prop6 = "D=v6" //pageUrl
    s.eVar6 = "http://"+document.location.host+location.pathname //pageUrl
    s.prop21 = "D=v21" //pageUrl
    s.eVar21 = "Suivez le guide – Site web" //medianame
    void(s.t());
});



// WEBPACK FOOTER //
// ./src/index.js